import { useContext } from 'react';
import { useQuery } from 'data-fetching-client';
import AILoadingButton from 'ai-components-ui-library/components/buttons/AILoadingButton';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import GenerateButtonTooltip from 'automation-ui-canvas/components/panels/ai-assistant-panel/GenerateButtonTooltip';
import { GET_AI_SETTINGS_ACCESS } from 'automation-ui-canvas/queries/aiSettingsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const GenerateButton = ({
  buttonText,
  regenerateButtonText,
  disabled,
  hasGenerateError,
  hasValidUserInput,
  isGenerateLoading,
  onGenerateClick,
  tooltipTitle,
  isRegenerating = false
}) => {
  var _aiSettingsData$aiSet;
  const {
    data: aiSettingsData
  } = useQuery(GET_AI_SETTINGS_ACCESS);
  const isContentAssistanceEnabled = (_aiSettingsData$aiSet = aiSettingsData === null || aiSettingsData === void 0 ? void 0 : aiSettingsData.aiSettingsAccess.crmPropertiesEnabled) !== null && _aiSettingsData$aiSet !== void 0 ? _aiSettingsData$aiSet : false;
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  return /*#__PURE__*/_jsx(GenerateButtonTooltip, {
    hasValidUserInput: hasValidUserInput,
    isContentAssistanceEnabled: isContentAssistanceEnabled,
    tooltipTitle: tooltipTitle,
    children: /*#__PURE__*/_jsx(AILoadingButton, {
      "data-test-id": "generate-ai-button",
      disabled: disabled || !isContentAssistanceEnabled || !hasValidUserInput,
      failed: hasGenerateError,
      loading: isGenerateLoading,
      onClick: () => onGenerateClick(),
      use: isRegenerating ? 'tertiary' : 'primary',
      usageTracker: usageTracker,
      isRegenerate: isRegenerating,
      children: isRegenerating && regenerateButtonText ? regenerateButtonText : buttonText
    })
  });
};
export default GenerateButton;